(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["department-carousel"] && !Shopify.designMode) return;
  try {
    
(window.webpackJsonp=window.webpackJsonp||[]).push([[5],[],[[212,0,1]]]);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(window.webpackJsonp=window.webpackJsonp||[]).push([[6],[],[[226,0,1]]]);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(window.webpackJsonp=window.webpackJsonp||[]).push([[7],[],[[222,0,1]]]);

  } catch(e) { console.error(e); }
})();
})();
